import { makeStyles } from '@material-ui/core/styles'

export const svgButtonStyles = makeStyles(({ ...theme }) => ({
    '@global': {
        '.svg-icon-red': { filter: 'brightness(0) saturate(100%) invert(40%) sepia(93%) saturate(3084%) hue-rotate(328deg) brightness(99%) contrast(105%)' },
        '.svg-icon-green': { filter: 'brightness(0) saturate(100%) invert(61%) sepia(77%) saturate(5368%) hue-rotate(130deg) brightness(97%) contrast(94%)' },
        '.svg-icon-blue': { filter: 'brightness(0) saturate(100%) invert(19%) sepia(55%) saturate(5589%) hue-rotate(246deg) brightness(102%) contrast(100%)' },
        '.svg-icon-black': { filter: 'brightness(0) saturate(100%)'},
    },
}))